import React from 'react';
export interface AsureCloudToastGroup {
  children: React.ReactNode;
  horizontalAlignment?: 'left' | 'right' | 'center';
  verticalAlignment?: 'top' | 'bottom';
}
/* Absolutely positioned element that requires the parent element to be position: relative. If you want these
notifications to appear in relation to the screen - they should be a direct child of the body tag.  */
export const AsureCloudToastGroup = ({children, horizontalAlignment, verticalAlignment}: AsureCloudToastGroup) => {
  return (
    <div className={`ac-toast-group d-flex flex-column ${horizontalAlignment} ${verticalAlignment}`}>
      {children}
    </div>
  )
}
export default AsureCloudToastGroup;

AsureCloudToastGroup.defaultProps = {
  horizontalAlignment: 'right',
  verticalAlignment: 'top'
}